"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Layout = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Layout"));

var _Loader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Loader"));

var _Card = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Card"));

var _Row = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Row"));

var _Col = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Col"));

var _Button = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Button"));

var _menus = require("cornerstone_ui_core/lib/components/menus");

var _CornerstoneLogoTrans = _interopRequireDefault(require("cornerstone_ui_core/lib/assets/img/CornerstoneLogoTrans.png"));

var _EsteeLogo = _interopRequireDefault(require("cornerstone_ui_core/lib/assets/img/EsteeLogo.png"));

var _cornerstoneLandingBg = _interopRequireDefault(require("cornerstone_ui_core/lib/assets/img/cornerstone-landing-bg.jpg"));

var _AutoLogout = _interopRequireDefault(require("cornerstone_ui_core/lib/components/AutoLogout"));

var _IsAuthorized = require("cornerstone_ui_core/lib/components/IsAuthorized");

var _logging = _interopRequireDefault(require("cornerstone_ui_core/lib/services/logging.service"));

var _Header = _interopRequireDefault(require("./Header"));

var _Sider = _interopRequireDefault(require("./Sider"));

var _baseLayout = require("./base-layout.helpers");

require("./base-layout.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// D:\ELC\Cornerstone UI\Feature TLM\cornerstone_ui_master\src\assets\img\EsteeLogo.png
var Content = _Layout.default.Content;

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      windowHeight: window.innerHeight,
      initialLoad: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (e) {
      _this.setState({
        windowHeight: window.innerHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sideNavToggle", function (e) {
      e.preventDefault();

      _this.props.sideNavToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function (e) {
      e.preventDefault();

      if (_this.requestAccess) {
        _this.logout();
      }
    });

    _this.checkAuthentication = _baseLayout.checkAuthentication.bind(_assertThisInitialized(_this));
    _this.logout = _baseLayout.logout.bind(_assertThisInitialized(_this));
    _this.login = _baseLayout.login.bind(_assertThisInitialized(_this));
    _this.requestAccess = _this.requestAccess.bind(_assertThisInitialized(_this));
    _this.findTImeout = _baseLayout.findTImeout.bind(_assertThisInitialized(_this));
    _this.requestAccessFlag = false;
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.removeEventListener("resize", this.handleResize);
                this.checkAuthentication();
                if (localStorage.getItem("AppId") !== "FEP") this.findTImeout();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener("resize", this.handleResize);
      if (this.state.initialLoad) this.props.setLoading(true);
    }
  }, {
    key: "requestAccess",
    value: function () {
      var _requestAccess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                localStorage.removeItem("jwtToken");
                _context2.next = 4;
                return this.props.auth.logout("/");

              case 4:
                window.open("https://hclelcprod.service-now.com/sp?id=mob_sc_category&sys_id=9168e8b7db24b74062172c860596198d", "_blank");
                this.login();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestAccess(_x) {
        return _requestAccess.apply(this, arguments);
      }

      return requestAccess;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          location = _this$props.location,
          loading = _this$props.loading,
          children = _this$props.children,
          user = _this$props.user,
          authenticated = _this$props.authenticated,
          entitlementStatus = _this$props.entitlementStatus,
          userPersonaList = _this$props.userPersonaList;
      if (loading) return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
      if (!authenticated) return /*#__PURE__*/_react.default.createElement("div", {
        className: "action-landing",
        style: {
          backgroundImage: "url(".concat(_cornerstoneLandingBg.default, ")")
        }
      }, /*#__PURE__*/_react.default.createElement(_Row.default, {
        span: 5,
        className: "header-row"
      }, /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 2
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _EsteeLogo.default,
        alt: "esteelogo",
        className: "img-fluid",
        style: {
          maxHeight: "75px"
        }
      })), /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 19
      }), /*#__PURE__*/_react.default.createElement(_Col.default, {
        span: 3
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _CornerstoneLogoTrans.default,
        alt: "CornerstoneLogo",
        className: "img-fluid",
        style: {
          maxHeight: "75px"
        }
      }))), /*#__PURE__*/_react.default.createElement(_Card.default, {
        className: "hello-card"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-sm-12 text-center"
      }, /*#__PURE__*/_react.default.createElement("h4", null, "Welcome to Cornerstone"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h5", null, "You have been logged out. Please login to continue."))), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-footer"
      }, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, {
        xs: 8,
        md: 8,
        lg: 8,
        offset: 9
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        htmlType: "submit",
        shape: "round",
        onClick: this.login
      }, "Login"))))), /*#__PURE__*/_react.default.createElement(_Row.default, {
        className: "position-fixed landing-footer"
      }, "\xA9 Est\xE9e Lauder Inc. All Rights Reserved"));
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AutoLogout.default, {
        logout: this.logout,
        login: this.login,
        userId: user && user.userId && user.userId.toUpperCase() || null
      }, /*#__PURE__*/_react.default.createElement(_IsAuthorized.UserContext.Provider, {
        value: user
      }, /*#__PURE__*/_react.default.createElement(_Layout.default, {
        id: "app-base-layout"
      }, /*#__PURE__*/_react.default.createElement(_Header.default, {
        user: user,
        logout: this.logout,
        userPersonaList: userPersonaList
      }), /*#__PURE__*/_react.default.createElement(_Layout.default, {
        style: {
          marginTop: "54px"
        },
        className: "left-sider-container"
      }, /*#__PURE__*/_react.default.createElement(_Sider.default, {
        menus: menuFilter((0, _menus.appMenu)(this.props.routes), user),
        user: user,
        location: location,
        logout: this.logout
      }), /*#__PURE__*/_react.default.createElement(_Layout.default, {
        className: (0, _classnames.default)("layout-right-to-sider")
      }, /*#__PURE__*/_react.default.createElement(Content, {
        style: {
          minHeight: "90vh",
          overflow: "initial"
        }
      }, children(user))))))));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      if (localStorage.getItem("AppId") !== "FEP") {
        (0, _logging.default)(error.stack, "ERROR");
        alert("Unhandled Error occured, Please press OK to reload. Errror details : " + error.message);
        window.location.reload(false);
      }
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;

function menuFilter(menus, user) {
  return menus.filter(function (menu) {
    return user.apps && (!menu.app || user.apps.includes(menu.app));
  }).filter(function (menu) {
    return haveRolePermission(menu, user);
  }).filter(function (menu) {
    return haveFnPermission(menu, user);
  }).map(function (menu) {
    if (menu.menus && menu.menus.length) {
      var clonedMenu = Object.assign({}, menu);
      clonedMenu.menus = menuFilter(clonedMenu.menus, user);
      if (clonedMenu.menus.length) return clonedMenu;else return null;
    }

    return menu;
  }).filter(function (m) {
    return !!m;
  });
}

function haveRolePermission(menu, user) {
  if (!menu.accessRoles) return true;
  if (!user || !user.roles) return false;
  var roles = user.roles.filter(function (role) {
    return role.appName === menu.app;
  });
  if (!roles.length) return false;
  var appRoles = roles[0].appRoles;
  var index = menu.accessRoles.findIndex(function (role) {
    return role.includes("!");
  });
  if (index !== -1) if (appRoles.includes(menu.accessRoles[index].split("!")[1])) return false;
  return appRoles.filter(function (role) {
    return menu.accessRoles.indexOf(role) !== -1;
  }).length;
}

function haveFnPermission(menu, user) {
  if (!menu.accessFns) return true;
  if (!user || !user.roles) return false;
  var roles = user.roles.filter(function (role) {
    return role.appName === menu.app;
  });
  if (!roles.length) return false;
  var appFns = roles[0].appFns;
  return appFns.filter(function (fns) {
    return menu.accessFns.indexOf(fns) !== -1;
  }).length;
}